// extracted by mini-css-extract-plugin
export default {"title":"portal_buttons_title__-60tt","buttonContainer":"portal_buttons_buttonContainer__zxCaM","text":"portal_buttons_text__US1Ej"};